<template>
  <div class="toast" :class="backgroundColor">
    <p class="toast-text bold">{{ data.text }}</p>
  </div>
</template>
<script>
  export default {
    name: 'toast',
    props: {
      data: {
        type: Object
      }
    },
    computed: {
      backgroundColor() {
        switch (this.data.type) {
          case 'error':
            return 'bg-color-error'
          case 'success':
            return 'bg-color-success-suitup'
          case 'reminder':
            return 'bg-color-reminder'
          default:
            return 'bg-color-neutral'
        }
      }
    }
  }
</script>
